<template>
<v-container grid-list-md text-xs-center>
  <v-layout row wrap>
    <v-flex xs12>
      <div style="height: 130px; background: rgb(236, 236, 236)">
        <v-icon style="float: right; font-size: 130px;color: rgb(250, 251, 251);">find_replace</v-icon>
      </div>
    </v-flex>

    <v-flex xs12>
      <v-card dark color="teal lighten-4">
        <v-card-text class="px-3 body text-xs-left " style="color: black"> Detect uttering's emotion of a North American English sentence.
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs4>
      <v-text-field label="Select .wav or .ogg file ..." @click='onPickFile' v-model='fileName' prepend-icon="attach_file"></v-text-field>
      <input
     type="file"
     style="display: none"
     ref="fileInput"
     accept="audio/wav,audio/ogg"
     @change="onFilePicked">
     </v-flex>

      <v-flex xs2>
        <v-btn color="teal lighten-3" @click.stop="onUploadSelectedFileClick" :loading="loading">Process</v-btn>
      </v-flex>

      <v-flex xs4>
        <v-chip :color="detectedEmotion.emotionIndex_0">Angry</v-chip>
        <v-chip :color="detectedEmotion.emotionIndex_1">Calm</v-chip>
        <v-chip :color="detectedEmotion.emotionIndex_2">Surprised</v-chip>
        <v-chip :color="detectedEmotion.emotionIndex_3">Happy</v-chip>
        <v-chip :color="detectedEmotion.emotionIndex_4">Sad</v-chip>
      </v-flex>
  </v-layout>
</v-container>
</template>

<style>
.icon-button-shadow {
  text-shadow: 2px 2px 6px #15b68187;
}

.lang-selector .v-input__control {
  min-width: 350px;
}
</style>

<script>
export default {
  name: 'lingo_emotion_detector',
  data() {
    return {
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      size: '',
      type: '',
      lastModifiedDate: '',
      loading: false,
      detectedEmotion: {}
    }
  },
  methods: {
    onPickFile() {
      this.clearEmotionTags();
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...

        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },
    onUploadSelectedFileClick() {
      this.clearEmotionTags();
      this.loading = true
      // A file is not chosen!
      if (!this.fileObject) {
        alert('No file!!')
      }

      const XHR = new XMLHttpRequest();
      // Bind the FormData object and the form element
      const FD = new FormData();
      FD.append("file", this.fileObject);

      var that = this;
      // Define what happens on successful data submission
      XHR.addEventListener("load", function(event) {
        that.highlightEmotionTag(JSON.parse(event.target.response));
        that.loading = false;
        //this.toggleEmotionProgressBar('completed')
        //alert( event.target.responseText );
      });

      // Define what happens in case of error
      XHR.addEventListener("error", function() {
        that.loading = false;
        alert('Oops! Something went wrong.');
      });

      // Set up our request
      XHR.open("POST", "https://ix1yzpx3ei.execute-api.eu-west-1.amazonaws.com/analyze_emotion");

      // The data sent is what is provided in the form
      XHR.send(FD);

      // https://developer.mozilla.org/en-US/docs/Web/API/File/File
      //this.name = this.fileObject.name
      //this.size = this.fileObject.size
      //this.type = this.fileObject.type
      //this.lastModifiedDate = this.fileObject.lastModifiedDate
    },
    clearEmotionTags() {
      this.detectedEmotion = {};
    },
    highlightEmotionTag(responseJson) {
      this.$set(this.detectedEmotion, "emotionIndex_" + responseJson.emotionsResult.emotions[0].emotionIndex, "teal lighten-3");
    }
  },
  components: {}
}
</script>
